"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MasterRepository = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const typeorm_2 = require("typeorm");
const constants_1 = require("../../../../service-lib/src/lib/constants");
const entities_1 = require("../../../../service-lib/src/lib/entities");
const entity_selection_utils_1 = require("../../../../service-lib/src/lib/utils/entity-selection.utils");
const get_entity_utils_1 = require("../../../../service-lib/src/lib/utils/get-entity.utils");
/**
 * MasterRepository
 * Handles database operations for generic CRUD operations on entities.
 */
let MasterRepository = class MasterRepository {
    constructor(dataSource, lookUpRepository) {
        this.dataSource = dataSource;
        this.lookUpRepository = lookUpRepository;
    }
    /**
     * Retrieves all records for the specified entity.
     */
    async getAllRecords(entity, search, searchId, searchBy, sortBy, sortOrder = "ASC", page = constants_1.DEFAULT_VALUES.PAGE, limit = constants_1.DEFAULT_VALUES.LIMIT) {
        try {
            const entityClass = (0, get_entity_utils_1.getEntityByName)(entity);
            const repository = this.dataSource.getRepository(entityClass);
            if (!repository) {
                throw new common_1.InternalServerErrorException("Invalid entity name");
            }
            const columnsToSelect = (0, entity_selection_utils_1.getSelectableColumns)(repository.metadata);
            const where = {};
            if (search && searchBy) {
                where[searchBy] = (0, typeorm_2.ILike)(`%${search}%`);
            }
            else if (searchId && searchBy) {
                where[searchBy] = searchId;
            }
            // Add status filter for active users
            if (entity === constants_1.DEFAULT_VALUES.USER_ENTITY) {
                where[constants_1.DEFAULT_VALUES.USER_STATUS_KEY] = constants_1.DEFAULT_VALUES.ACTIVE_USER_STATUS;
            }
            const order = {};
            if (sortBy && sortOrder) {
                order[sortBy] = sortOrder;
            }
            const result = (await repository.find({
                select: columnsToSelect,
                ...(Object.keys(where).length > 0 && { where }),
                ...(Object.keys(order).length > 0 && { order }),
            }));
            const offset = (page - 1) * limit;
            return { data: result.slice(offset, offset + limit) };
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(error instanceof Error ? error.message : "Failed to retrieve records");
        }
    }
    /**
     * Retrieves a single record by ID for the specified entity.
     */
    async getRecordById(entityClass, id) {
        try {
            const repository = this.dataSource.getRepository(entityClass);
            if (!repository) {
                throw new common_1.InternalServerErrorException("Invalid entity name");
            }
            const columnsToSelect = (0, entity_selection_utils_1.getSelectableColumns)(repository.metadata);
            const record = await repository.findOne({
                select: columnsToSelect,
                where: { id },
            });
            if (!record) {
                throw new common_1.InternalServerErrorException(`Record not found with id ${id}`);
            }
            return { data: record };
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(error instanceof Error ? error.message : "Failed to retrieve record");
        }
    }
    /**
     * Creates a new record for the specified entity.
     */
    async createRecord(entityClass, data) {
        try {
            const repository = this.dataSource.getRepository(entityClass);
            if (!repository) {
                throw new common_1.InternalServerErrorException("Invalid entity name");
            }
            const newData = {
                ...data,
                createdBy: constants_1.DEFAULT_VALUES.CREATED_BY,
                updatedBy: constants_1.DEFAULT_VALUES.UPDATED_BY,
            };
            const recorData = await repository.save(newData);
            const { createdBy, updatedBy, createdAt, updatedAt, ...filteredData } = recorData;
            return filteredData;
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(error instanceof Error ? error.message : "Failed to create record");
        }
    }
    /**
     * Updates an existing record by ID for the specified entity.
     */
    async updateRecordById(entityClass, id, data) {
        try {
            const repository = this.dataSource.getRepository(entityClass);
            if (!repository) {
                throw new common_1.InternalServerErrorException("Invalid entity name");
            }
            const columnsToSelect = (0, entity_selection_utils_1.getSelectableColumns)(repository.metadata);
            const existingRecord = await repository.findOne({ where: { id } });
            if (!existingRecord) {
                throw new common_1.InternalServerErrorException(`Record not found with id ${id}`);
            }
            const updatedData = {
                ...data,
                updatedBy: constants_1.DEFAULT_VALUES.UPDATED_BY,
            };
            await repository.update(id, updatedData);
            const updatedRecord = await repository.findOne({
                select: columnsToSelect,
                where: { id },
            });
            return updatedRecord;
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(error instanceof Error ? error.message : "Failed to update record");
        }
    }
    /**
     * Deletes a record by ID for the specified entity.
     */
    async deleteRecordById(entityClass, id) {
        try {
            const repository = this.dataSource.getRepository(entityClass);
            if (!repository) {
                throw new common_1.InternalServerErrorException("Invalid entity name");
            }
            const record = await repository.findOne({ where: { id } });
            if (!record) {
                throw new common_1.InternalServerErrorException(`Record not found with id ${id}`);
            }
            await repository.delete(id);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(error instanceof Error ? error.message : "Failed to delete record");
        }
    }
};
exports.MasterRepository = MasterRepository;
exports.MasterRepository = MasterRepository = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__param(1, (0, typeorm_1.InjectRepository)(entities_1.LookUp)),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof typeorm_2.DataSource !== "undefined" && typeorm_2.DataSource) === "function" ? _a : Object, typeof (_b = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _b : Object])
], MasterRepository);
